import React from 'react';
import { Box, Card, CardContent, Stack, Typography } from '@mui/material';

const MetricCard = ({ label, value, helper, icon }) => {
    return <Card sx={{ height: '100%', overflow: 'visible' }}>
        <CardContent sx={{ p: 2.5, '&:last-child': { pb: 2.5 } }}>
            <Stack direction="row" justifyContent="space-between" spacing={2}>
                <Box>
                    <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 650 }}>{label}</Typography>
                    <Typography variant="h4" sx={{ mt: .6 }}>{value}</Typography>
                    {helper && <Typography variant="caption" color="text.secondary">{helper}</Typography>}
                </Box>
                <Box sx={{ mt: -.5 }}>{icon}</Box>
            </Stack>
        </CardContent>
    </Card>;
};

export default MetricCard;
